<template>
  <Modal
    class="project-analysis-text-modal"
    header-tag="h3"
    uid="modal-banned-keywords"
    :ref="modalRef"
    :show="show"
    :thinFormat="true"
    @close="closeModal"
  >
    <template #header>
      <VisibleText>Banned Keywords</VisibleText>
    </template>
    <p>
      <VisibleText
        >You can prevent some overly common words from appearing in your generated themes.
      </VisibleText>
    </p>
    <p class="hint-text" id="banned-keyword-hint">
      <VisibleText>Hit enter to add a word to the banned keywords list. </VisibleText>
    </p>
    <KeywordsInput
      class="banned-keywords__ki-wrapper"
      ref="banned-keywords-input"
      hint-id="banned-keyword-hint"
      :key="updateKey"
      :value="taggable(textAnalysisObject.bannedKeywords)"
      @keywords-updated="handleKeywordsUpdate"
      :textAnalysisObject="textAnalysisObject"
      :hasPreProcessedText="hasPreProcessedText"
    />
    <template #footer>
      <button
        class="banned-keywords__save-btn btn-default"
        type="button"
        @click.prevent="save"
        :disabled="!unsavedChanges || textAnalysisObject.showSpinner || propReadOnly"
      >
        <VisibleText>Save changes</VisibleText>
      </button>
      <button class="btn-cancel" type="button" @click="closeModal">
        <VisibleText>Close</VisibleText>
      </button>
    </template>
  </Modal>
</template>

<script>
// Components
import Modal from '@/components/UI/Modal.vue';
import KeywordsInput from '../Components/KeywordsInput.vue';

// Mixins
import textAnalysisMixin from '../../Mixins/textAnalysisMixin.js';

// Lib
import _ from 'lodash';

export default {
  name: 'BannedKeywords',
  mixins: [textAnalysisMixin],
  components: {
    Modal,
    KeywordsInput,
  },
  props: {
    show: {
      default: () => false,
      type: Boolean,
    },
    textAnalysisObject: {
      type: Object,
      required: false,
      default: () => {},
    },
    hasPreProcessedText: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },

  data() {
    return {
      unsavedChanges: false,
      updateKey: Date.now(),
    };
  },
  mounted() {
    this.closeModal = this.closeModal.bind(this);
  },
  methods: {
    taggable(keywords) {
      return keywords.map(
        function (text, index) {
          return { key: index, value: this.clean(text) };
        }.bind(this),
      );
    },
    clean(keyword) {
      return keyword.trim().toLowerCase();
    },
    handleKeywordsUpdate() {
      if (
        _.isEqual(
          this.textAnalysisObject.bannedKeywords,
          this.$refs['banned-keywords-input'].tags.map((el) => el.value),
        )
      ) {
        return;
      }
      this.unsavedChanges = true;
    },
    async save() {
      // update store
      const bannedKeywords = this.$refs['banned-keywords-input'].tags.map((el) => el.value);
      const bannedKeywordsOld = [...this.textAnalysisObject.bannedKeywords];

      // set to mixin and to project, do it in one go?
      this.setBannedKeywords(bannedKeywords);

      // save to backend
      this.setShowSpinner(true);
      try {
        // success
        this.showModalMessage('success', `Your changes have been saved successfully.`);
        this.unsavedChanges = false;
      } catch (e) {
        this.showModalMessage('error', 'An error occured. Please try again later.');
        // revert the changes
        this.setBannedKeywords(bannedKeywordsOld);
        throw new Error('BannedKeywords.vue:save: ' + e);
      } finally {
        this.setShowSpinner(false);
      }
    },
    closeModal() {
      if (this.unsavedChanges) {
        if (!confirm('You have unsaved changes. Are you sure you want to continue?')) {
          return;
        }
      }
      this.unsavedChanges = false;
      this.$emit('closeModal');
    },
  },
  computed: {
    thisBannedKeywords() {
      return this.textAnalysisObject.bannedKeywords;
    },
  },
  watch: {
    thisBannedKeywords: function (val) {
      if (val.length > 0) {
        this.bannedKeywords_ = this.thisBannedKeywords; // is this being used?
        this.updateKey = Date.now();
      }
    },
    show: function (val) {
      if (val) this.unsavedChanges = false;
    },
  },
};
</script>
